import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './style.scss';

const Accordion = ({ title, children, open = false, decorator = true, className, ...restProps }) => {
  const [active, toggleActive] = useState(open);

  return (
    <div
      className={clsx('accordion', className)}
      {...restProps}
    >
      <div
        className="accordion__title"
        onClick={() => toggleActive(!active)}
      >
        {title}
        <i>
          { decorator && (
            active ? (
              <FontAwesomeIcon icon={['fal', 'minus']} />
            ) : (
              <FontAwesomeIcon icon={['fal', 'plus']} />
            )
          )}
        </i>
      </div>
      {active && (
        <div className={clsx('accordion__content')}>
          {children}
        </div>
      )}
    </div>
  );
};

Accordion.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  open: PropTypes.bool,
};

export default Accordion;
